import { VFC } from 'react'
import { safetyOrange, softOrange, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { FormItemWrapper, labelHoverEffectStyle } from './common'

type FormSelectedItemsProps = {
  id: string
  label: string
  items: string[]
  setIsOpen: (open: boolean) => void
  optional?: boolean
}
export const FormSelectedItems: VFC<FormSelectedItemsProps> = ({
  id,
  label,
  items,
  setIsOpen,
  optional,
}) => {
  return (
    <FormItemWrapper id={id} label={label} optional={optional ?? true}>
      {items && items.length ? (
        <SelectedItemsButton type="button" onClick={() => setIsOpen(true)}>
          <SelectedItemsSpan>
            {items.map((item, index) => {
              return <div key={index}>{item}</div>
            })}
          </SelectedItemsSpan>
        </SelectedItemsButton>
      ) : (
        <SettingDiv blur={false}>
          <SettingButton type={'button'} onClick={() => setIsOpen(true)}>
            {'＋ 設定する'}
          </SettingButton>
        </SettingDiv>
      )}
    </FormItemWrapper>
  )
}

const SelectedItemsSpan = styled.span`
  width: 100%;
  margin: auto 0;
  color: ${safetyOrange};

  div {
    display: inline-block;
    width: auto;
    margin: 4px;
    padding: 5px 10px;
    font-weight: ${fontWeightBold};
    background: ${softOrange};
    border: solid 1px ${safetyOrange};
    border-radius: 15px;
    white-space: pre-wrap;
  }
`

const SettingDiv = styled.div<{ blur: boolean }>`
  width: 100%;
  border-radius: 5px;
  padding: 20px 15px;
  text-align: center;
  position: relative;
  ${({ blur }) =>
    blur
      ? `
      &::after {
        border: dashed 1px ${safetyOrange};
        background: ${softOrange};
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        filter: blur(3.5px);
        background: inherit;
        border: dashed 1px ${safetyOrange};
        background: ${softOrange};
        z-index: -1;
      }
    `
      : `
      border: dashed 1px ${safetyOrange};
      background: ${softOrange};
    `};
`

const SettingButton = styled.button`
  margin: auto;
  font-weight: ${fontWeightBold};
  border: solid 1px;
  border-radius: 5px;
  padding: 10px 24px;
  color: ${safetyOrange};
  background: ${truewhite};
`

const SelectedItemsButton = styled.button<{ textAlign?: string }>`
  display: block;
  border: dashed 1px ${safetyOrange};
  padding: 20px 15px;
  text-align: ${(props) => props.textAlign || ''};
  background: ${truewhite};

  ${labelHoverEffectStyle};
`
